import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

const initialState: any = {
  userId: "",
  userType: "",
  Permissions: "",
};

const verifyEmailSlice = createSlice({
  name: "verifyEmail",
  initialState,
  reducers: {
    setUserId: (state: any, action: PayloadAction<any>) => {
      state.userId = action.payload;
    },
    setUserType: (state: any, action: PayloadAction<any>) => {
      state.userType = action.payload;
    },
    setUserPermissions: (state: any, action: PayloadAction<any>) => {
      state.permissions = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setUserId, setUserType, setUserPermissions } =
  verifyEmailSlice.actions;

export default verifyEmailSlice.reducer;
